import { __assign } from "tslib";
import { normalizeRegion } from "./normalizeRegion";
export var resolveRegionConfig = function resolveRegionConfig(input) {
  if (!input.region) {
    throw new Error("Region is missing");
  }

  return __assign(__assign({}, input), {
    region: normalizeRegion(input.region)
  });
};